import { render } from "./settingsAside.vue?vue&type=template&id=456620c0&scoped=true"
import script from "./settingsAside.vue?vue&type=script&lang=js"
export * from "./settingsAside.vue?vue&type=script&lang=js"

import "./settingsAside.vue?vue&type=style&index=0&id=456620c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456620c0"]])

export default __exports__